<ng-container *ngIf="!isHidden">
  <ng-content></ng-content>
</ng-container>
